import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'owner',
      label: '群主工作账号',
      type: 'input',
      placeholder: '请输入群主工作账号'
    },
    {
      field: 'custName',
      label: '客户昵称',
      type: 'input',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'usedBy',
      label: '群主姓名',
      type: 'input',
      placeholder: '请输入群主姓名'
    },
    {
      field: 'reasonType',
      type: 'select',
      label: '原因类型',
      placeholder: '请选择原因类型',
      filterable: true,
      options: [
        {title: '成交客户', value: '1'},
        {title: '5个月内回复过的客户', value: '2'},
        {title: '5个月内未回复且加入时间未满6月', value: '3'}
      ]
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '拉群时间段',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
          return date.getTime() < sixMonthsAgo.getTime();
        }
      }
    },
    {
      field: 'sysDate',
      type: 'datepicker',
      label: '查询日期',
      otherOptions: {
        placeholder: '选择日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
